import { createContext } from 'react';
export const UnseenCountContext = /*#__PURE__*/createContext(0);
UnseenCountContext.displayName = 'Unseen notification count context';